import { createContext, useReducer, ReactElement, Dispatch } from 'react';
import initState, { IState, channelDataType } from './state';
import { IAction, ActionTypeValues } from './actionTypes';
import namespace from './namespace';
import reducer from './reducer';

interface IContextProviderProps {
  initialStore?: IState,
  children: ReactElement | ReactElement[];
}

interface IStoreContext {
  dispatch: Dispatch<IAction<any> | Array<IAction<any>>>;
  resetState: Dispatch<Pick<IAction<any>, 'namespace'> & { resetKeys: string[] }>;
  state: IState;
}

const StoreContext = createContext<IStoreContext>({
  dispatch: () => null,
  resetState: () => null,
  state: {} as IState,
});

function useContextProvider({ initialStore, children }: IContextProviderProps) {
  const [state, dispatch] = useReducer(reducer, {...initState(), ...initialStore});

  const dispatchMultipleActions = (actions: Parameters<IStoreContext['dispatch']>[0]) => {
    if (Array.isArray(actions)) {
      actions.forEach((action) => {
        dispatch(action);
      });
    } else {
      dispatch(actions);
    }
  };

  const resetState = (action: Parameters<IStoreContext['resetState']>[0]) => {
    dispatch({
      type: ActionTypeValues.RESET_PAGE_STATE,
      payload: action,
      namespace: namespace.app,
    });
  };

  return (
    <StoreContext.Provider value={{ state, dispatch: dispatchMultipleActions, resetState }}>
      {children}
    </StoreContext.Provider>
  );
}

export type { IState, IAction, channelDataType };

export { StoreContext, ActionTypeValues, namespace };

export default useContextProvider;
